module.exports = __webpack_public_path__ + "0ef417cbe39e0ffa1d75673da7bfe3c0.svg";